import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import store from '../store'
Vue.use(VueI18n)

const defaultLocale = 'tw'

const messages = {
    tw: {
      AlarmState: {
        opened: "待追蹤",
        processing: "處理中",
        pending: "暫時不處理",
        verifying: "審查中",
        rejected: "審查不通過，請再修正",
        closed: "已結案"
      },  
      NotifyTargets: {
        user:	"用戶",
        manufacturer: "廠商",
        survey: "現場勘查",
        other: "其他"
      },
      Title: "智慧水管家",
      Version: "臺北自來水事業處 版本 0.2.121 [2026-03-24]",
      Warning: {
        empty:	"無法擷取資料!"
      },
      Element: {
        selectPlaceholder: "請選擇"
      },
      Profile: {
        waterUsageStatus: "用水狀況",
        waterRegistrationID: "用戶水號",
        meterNumber: "用戶表號",
        address: "住址",
        waterUsageOfMonth: "本月已用",
        m3: "度",
        waterUsageDetail: "，用水情形",
        waterUsageDetailNormal: "正常使用",
        waterUsageDetailLost: "斷訊",
        waterUsageDetailLostDays: "斷訊{day}天",
        waterUsageDetailInstalled: "已建點未回傳",
        waterUsageDetailUnknown: "未知狀態"
      },
      History: {
        title: "歷史曲線圖",
        day: "日",
        week: "週",
        month: "月",
        year: "年",
        customDate: "日期",
        plot: "繪製歷史曲線圖",
        empty: "選擇的日期區間內，尚無資料",
        flow: "流量(m³/h)",
        logTime: "訊號時間",
        instantFlow: "瞬間值",
        totalizerLog: "積算值"
      },
      Situation: {
        title: "用水情形比較",
        comparisonBenchmark: "比較基準",
        month: "月份",
        period: "期別",
        empty: "無資料",
        flow: "流量(度)",
        lastYearMonth: "去年同月",
        thisMonth: "本月",
        lastMonth: "上月",
        lastYearPeriod: "去年同期",
        thisPeriod: "本期",
        lastPeriod: "上期",
        readingRecordingDate: "(抄表日:{date})",
        readingRecordingDateEmpty: "無"
      },
      RecordComparison: {
        title: "用水量比較圖",
        day: "日",
        month: "月",
        empty: "選擇的日期區間內，尚無資料",
        waterUsage: "用水度數",
        m3: '噸',
        date: "日期",
        normal: "無異常",
        noData: "無資料",
        reversed: "水表度數逆轉",
        notCompleted: "數據不完整",
        replaced: "有換表紀錄"
      },
      Record: {
        title: "用水量查詢",
        day: "日",
        week: "週",
        month: "月",
        year: "年",
        weekHint: "一周為周一開始，周日結束",
        empty: "選擇的日期區間內，尚無資料",
        normal: "無異常",
        reversed: "水表逆轉",
        notCompleted: "數據不完整",
        replaced: "換表",
        startTime: "開始日期",
        endTime: "結束日期",
        waterUsage: "用水度數",
        m3: '噸',
        chartHint: "說明：資料傳輸可能因環境與電信通訊等因素，造成訊息短暫未回傳情形，惟不影響計費正確性。"
      },
      Trend: {
        title: "日用水趨勢圖",
        dayHint1: "以「前",
        dayHint2: "日」計算標準差與平均值",
        standardDeviationCtrl: "顯示標準差線圖",
        show: "顯示",
        hide: "隱藏",
        day: "日",
        verticalAxisCtrl: "Y軸起迄區間",
        verticalAxisDefault: "自動",
        verticalAxisCustomize: "自訂",
        verticalAxisFrom: "Y軸起始值",
        verticalAxisTo: "Y軸結束值",
        plot: "繪製趨勢圖",
        empty: "選擇的日期區間內，尚無資料",
        flow: "流量(m³/h)",
        logTime: "訊號時間",
        instantFlow: "瞬間值",
        totalizerLog: "積算值",
        dayAverage: "日均值",
        standardDeviation: "標準差",
        chartHint: "說明：資料傳輸可能因環境與電信通訊等因素，造成訊息短暫未回傳情形，惟不影響計費正確性。"
      }
    },
    en: {
      Title: "Smart Water Management Platform",
      Version: "VERSION: 0.2.121 | Last Updated 24 Mar. 2026 |© TAIPEI WATER DEPARTMENT",
      Warning: {
        empty:	"Unable to retrieve data!"
      },
      Element: {
        selectPlaceholder: "Select"
      },
      Profile: {
        waterUsageStatus: "Water Usage Status",
        waterRegistrationID: "Water registration ID",
        meterNumber: "Meter Number",
        address: "Address",
        waterUsageOfMonth: "Water usage this month",
        m3: "m³",
        waterUsageDetail: ", Water Usage Status",
        waterUsageDetailNormal: "Normal Use",
        waterUsageDetailLost: "No Signal",
        waterUsageDetailLostDays: "{day} days no signal",
        waterUsageDetailInstalled: "Installed But No Response",
        waterUsageDetailUnknown: "Unknown Status"
      },
      History: {
        title: "Historical Trend Chart",
        day: "Day",
        week: "Week",
        month: "Month",
        year: "Year",
        customDate: "custom",
        plot: "Plot a historical trend chart",
        empty: "No Data",
        flow: "Flow(m³/h)",
        logTime: "Log Time",
        instantFlow: "Instant Flow",
        totalizerLog: "Totalizer Log"
      },
      Situation: {
        title: "Water Usage Comparison",
        comparisonBenchmark: "Comparison Benchmark",
        month: "Month",
        period: "Period",
        empty: "No Data",
        flow: "Flow(ton)",
        lastYearMonth: "Same Month Last Year",
        thisMonth: "This Month",
        lastMonth: "Last Month",
        lastYearPeriod: "Same Period Last Year",
        thisPeriod: "Current Period",
        lastPeriod: "Previous Period",
        readingRecordingDate: "\n(Meter reading recording date: {date})",
        readingRecordingDateEmpty: "No Data"
      },
      RecordComparison: {
        title: "Water Usage Comparison Chart",
        day: "Day",
        month: "Month",
        empty: "No Data",
        waterUsage: "Water Usage",
        m3: 'm³',
        date: "Date",
        normal: "No Abnormality",
        noData: "No Data",
        reversed: "Reverse Flow",
        notCompleted: "Incomplete Data",
        replaced: "Meter Replacement"
      },
      Record: {
        title: "Water Usage Inquiry",
        day: "Day",
        week: "Week",
        month: "Month",
        year: "Year",
        weekHint: "Weeks start on Monday and end on Sunday.",
        empty: "No Data",
        normal: "No Abnormality",
        reversed: "Reverse Flow",
        notCompleted: "Incomplete Data",
        replaced: "Meter Replacement",
        startTime: "Start Time",
        endTime: "End Time",
        waterUsage: "Water Usage",
        m3: 'm³',
        chartHint: "Data transmission may be temporarily unavailable due to environmental conditions or telecommunications issues; however, this will not affect billing accuracy."
      },
      Trend: {
        title: "Daily Water Usage Trend Chart",
        dayHint1: "The standard deviation and average are calculated based on the past",
        dayHint2: "days",
        standardDeviationCtrl: "Line graph with standard deviation",
        show: "Show",
        hide: "Hide",
        day: "Days",
        verticalAxisCtrl: "Scale values of the vertical axis",
        verticalAxisDefault: "Default",
        verticalAxisCustomize: "Customize",
        verticalAxisFrom: "From",
        verticalAxisTo: "To",
        plot: "Plot A Trend Chart",
        empty: "No Data",
        flow: "Flow(m³/h)",
        logTime: "Log Time",
        instantFlow: "Instant Flow",
        totalizerLog: "Totalizer Log",
        dayAverage: "-day average",
        standardDeviation: "Standard Deviation",
        chartHint: "Data transmission may be temporarily unavailable due to environmental conditions or telecommunications issues; however, this will not affect billing accuracy."
      }
    }
}

const i18n = new VueI18n({
    /** 默认值 */
    locale: defaultLocale,
    messages
})

export default i18n